/*
 * @Author: renjie
 * @description：  权益相关 路由
 */
const route = [
  {
    path: '/hospital/rights/haoyibao/auth',
    name: 'haoyibaoAuth',
    component: () => import(/* webpackPrefetchPlaceHolder */ './haoyibao/auth'),
    auth: true,
    exact: true,
    title: '实名认证',
  },
  {
    path: '/hospital/rights/haoyibao/stepfirst',
    name: 'haoyibaoStepFirst',
    component: () => import(/* webpackPrefetchPlaceHolder */ './haoyibao/stepFirst'),
    auth: true,
    exact: true,
    title: '好医保门诊险',
  },
  {
    path: '/hospital/rights/haoyibao/stepsecond',
    name: 'haoyibaoStepSecond',
    component: () => import(/* webpackPrefetchPlaceHolder */ './haoyibao/stepSecond'),
    auth: true,
    exact: true,
    title: '好医保门诊险',
  },
  {
    path: '/hospital/rights/childteeth',
    name: 'childteeth',
    component: () => import(/* webpackPrefetchPlaceHolder */ './childTeeth/index'),
    exact: true,
    title: '儿童齿科服务',
  },
];
export default route;

